import React from 'react';
import SelectTransferAccountFP from '../FullPagesComponents/Services/Amount/SelectTransferAccountFP';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';

//= ========================================================================

const PayingAccountDF = ({
  globJSON,
  selectedScreen,
  simPlatform,
  withArrow,
  isBlueBorder,
  withThreeCard,
  isAccountBalanceService,
  isPayBillService,
  accountInfo,
  slideshowRefs,
}) => (
  <SimulatorsViewerArrangement
    simPlatform={simPlatform}
  >
    <SelectTransferAccountFP
      globJSON={globJSON}
      selectedScreen={selectedScreen}
      simPlatform={simPlatform}
      withArrow={withArrow}
      isBlueBorder={isBlueBorder}
      withThreeCard={withThreeCard}
      isAccountBalanceService={isAccountBalanceService}
      isPayBillService={isPayBillService}
      accountInfo={accountInfo}
      slideshowRefs={slideshowRefs}
    />
  </SimulatorsViewerArrangement>
);

export default PayingAccountDF;
